import BNJ_EXT_1 from "./BNJ_EXT_1";
export default {
  BNJ_EXT_1,
};
